import React from "react";
import { useSelector, useDispatch } from "react-redux";
import FloatingDialer from "./floating-dialer";
import {
  closeDialer,
  updateCallStatus,
} from "../../redux/actions/globalDialerAction";

const GlobalDialerContainer = () => {
  const dispatch = useDispatch();
  const { isDialerOpen, phoneNumber } = useSelector(
    (state) => state.globalDialer
  );

  const handleCloseDialer = () => {
    dispatch(closeDialer());
  };

  const handleCallStatusChange = (status, data) => {
    dispatch(updateCallStatus(status, data));
  };

  if (!isDialerOpen) {
    return null;
  }

  return (
    <FloatingDialer
      phoneNumber={phoneNumber}
      onClose={handleCloseDialer}
      onCallStatusChange={handleCallStatusChange}
    />
  );
};

export default GlobalDialerContainer;
